import React from "react"
import { TiptapReadOnlyContent } from "../../../../component/tiptapEditor"
import QuestionArtifacts from "../../../../component/questionArtifacts/QuestionArtifacts"
import {
  displayableArtifacts,
  type ArtifactLike,
} from "../../../../utils/generatedArtifacts"
import "./PaperQuestionStem.style.scss"

interface PaperQuestionStemProps {
  html: string
  artifacts?: ArtifactLike[] | null
  compact?: boolean
}

const PaperQuestionStem = ({
  html,
  artifacts,
  compact = false,
}: PaperQuestionStemProps) => {
  const content = (html || "").trim()
  const hasArtifacts = displayableArtifacts(artifacts).length > 0
  if (!content && !hasArtifacts) {
    return <p className="paper-question-stem is-empty">Question</p>
  }

  return (
    <div
      className={`paper-question-stem${compact ? " is-compact" : ""}`}
    >
      {content ? <TiptapReadOnlyContent html={content} /> : null}
      <QuestionArtifacts artifacts={artifacts} compact={compact} />
    </div>
  )
}

export default PaperQuestionStem
